module.exports = __webpack_public_path__ + "static/media/truck.5fd8f206.svg";